import React from 'react'
import Select from 'react-select';
import Flag from 'react-world-flags';

export default function SelectReact(props) {
  const selectOptions = [
    { value: "USD", label: "USD", flag: 'USA' },
    { value: "CAD", label: "CAD", flag: 'CAN' },
    { value: "EUR", label: "EUR", flag: 'FRA' },
    { value: "GBP", label: "GBP", flag: 'GBR' },
    { value: "JPY", label: "JPY", flag: 'JPN' },
    { value: "MXN", label: "MXN", flag: 'MEX' },
    { value: "VND", label: "VND", flag: 'VNM' },
    { value: "ZAR", label: "ZAR", flag: 'ZAF' },
  ];


  return (
    <Select
      onChange={props.onChange}
      options={selectOptions}
      components={{ Option: customOption }}
      placeholder={props.placeholder}
      cursor="pointer"
      menuPlacement="top"
      inputProps={{ inputMode: 'numeric' }}
      isSearchable={false}
      readOnly={true}
      readonly

    />
  )
}

const customOption = ({ innerRef, innerProps, data }) => {
  return (
    <div className="select-options" ref={innerRef} {...innerProps} >
      <Flag className="select-flag" code={data.flag} /> &nbsp;{data.label}
    </div >
  )
}


